import {
  type RequirementsItemProps,
  type RequirementType,
} from '../types/components';

interface GetRequirementsByType {
  list: RequirementsItemProps[];
  type: RequirementType;
}

const filterRequirementsByType = ({
  list,
  type,
}: GetRequirementsByType): RequirementsItemProps[] =>
  list.filter((req) => req.type === type);

export { filterRequirementsByType };
